$( document ).ready(function() {
    $("header" ).on( "click", ".header-menu-ic", function(event) {
        event.preventDefault();

        $( this ).parents('header').toggleClass( "is-active" );
        $( this ).toggleClass( "is-active" );
        $('.header-menu').toggleClass( "is-active" );
        $('html').toggleClass( "is-ovf");
    });


});